import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../../redux/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { selectCurrentTab, setQuery, setupQuery } from '../../../redux/queryBuilderSlice';


const QueryMeasures = ({currentActiveTab}:{currentActiveTab:number}) => {

    const dispatch = useDispatch<AppDispatch>();
        // const currentActiveTab = useSelector((state:any) => state.queryBuilder.currentTabIndex);
    
    const { measures } = useSelector((state: RootState) => state.meta.metaStates[currentActiveTab]);
    const currTabData = useSelector(selectCurrentTab);
    
    const query = useSelector((state: RootState) => currTabData.query);
            
    const handleClick = (uniqueName: string) => {
        if (query && query.axes) {
            const cols = query.axes["COLUMNS"];
            const updatedCols = cols.includes(uniqueName) ? cols.filter((item:any) => item !== uniqueName) : [...cols, uniqueName];    
            const updatedQuery = {
                ...query,
                axes: {
                    ...query.axes,
                    COLUMNS: updatedCols
                }
            };
            //dispatch(setupQuery(updatedQuery));
            dispatch(setQuery({query:updatedQuery,currentTabIndex:currentActiveTab}));
        }
	}

    return (
        <div className="measures-section">
		    <div className="measures-header">Calculations & Metrics</div>
            <div className="measures-list">
            {measures?.map(measure => (
                <div className="measure-node">
                <div className= {query && query.axes && query.axes["COLUMNS"].length > 0 && query.axes["COLUMNS"].includes(measure.uniqueName) ? "measures selected" : "measures"} key={measure.caption}
                    onClick={() => handleClick(measure.uniqueName)}>  
			        <span className="nav-label">
                    {query && query.axes && query.axes["COLUMNS"].length > 0 && query.axes["COLUMNS"].includes(measure.uniqueName) ? (<span className='nav-label'>
                        <FontAwesomeIcon className="nav-label-check" icon={faCircleCheck} /></span>): null}
                        {measure.caption}
                    </span>
                </div>
                </div>
            ))}
            </div>
        </div>
    )
};

export default QueryMeasures;